'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.openModal = openModal;

exports.default = function () {};

var _abp = require('abp');

var _abp2 = _interopRequireDefault(_abp);

var _linksoft = require('linksoft');

var _notify = require('linksoft/notify');

var _notify2 = _interopRequireDefault(_notify);

var _localize = require('linksoft/core/localize');

var _localize2 = _interopRequireDefault(_localize);

var _select = require('linksoft/initializers/select2');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var $ = require("jquery");

var Resx = (0, _localize2.default)('Common');

$(document).on('click', '[data-table-edit-modal-url]', function () {
    openModal($(this).attr('data-table-edit-modal-url'), 'edit-modal-container');
});

function openModal(url, selector) {
    $('#' + selector + ' .modal-body');
    //.html('<div class="form-container loading" style="height:100px"></div>');
    $('#' + selector).modal('show');
    $.ajax({ url: url, method: 'GET' }).done(function (result) {
        $('#' + selector + ' .modal-body').html(result);
        if ($('#' + selector).unblock) {
            $('#' + selector).unblock();
        }

        $('#' + selector + ' .modal-body > select').each(function () {
            (0, _select.initSelect2)($(this));
        });
    }).fail(function (result) {
        _notify2.default.error(Resx.Common.AjaxError);
        $('#' + selector).modal('hide');
    });
    return false;
}

$(document).on('click', '[data-edit-modal-close]', function () {
    closeEditModal();
    closeConfirmationModal();
    return false;
});

$(document).on('click', '[data-edit-modal-close-and-reload]', function () {
    window.location.reload(true);
});

function closeConfirmationModal() {
    $('#confirmation-modal-container').modal('hide');
}

function closeEditModal() {
    $('#edit-modal-container').modal('hide');
}

;


//////////////////
// WEBPACK FOOTER
// ./Scripts/app/edit-modal.js
// module id = 430
// module chunks = 0